/*
 * jBone.widget.paging
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var $ = require('j');
    var tmpl = require('tmpl');
    var mathAlgorithms = require('util/math.util').algorithms;
    var device = require('util/device.util');

    require('common/jbone.widget');

    module.exports = $.widget('custompaging', {

        /**
         * Options by default
         * @type {Object}
         */
        options: {

            /**
             * How often internal update callbacks will be fired
             * @type {Number}
             */
            throttleValue: 200,

            /**
             * Current page
             * @type {Number}
             */
            activeItem: 0,

            /**
             * How many items will be visible at once
             * @type {Number}
             */
            itemCountToShow: 5,

            /**
             * How many items will be scrolled at one scroll action
             * @type {Number}
             */
            itemCountToScroll: 3,

            /**
             * On which devices arrows will be enabled
             * @type {Number}
             */
            showArrowsOnDevices: ['desktop', 'tablet', 'mobile'],

            /**
             * On which devices swipe scroll will be enabled
             * @type {Number}
             */
            enableSwipeOnDevices: ['desktop', 'tablet', 'mobile'],

            /**
             * Callback that fires every time when position changes
             * @type {Number}
             */
            changeCallBack: null,

            /**
             * Time for slide animation
             * @type {Number}
             */
            animationTime: 150,

            /**
             * Animation function for sliding, see in math.util.algorithms.*
             * @type {Function}
             */
            slideAnimationFunction: mathAlgorithms.easeOutQuint
        },

        triggerChangeCallback: function() {
            this.options.changeCallBack && this.options.changeCallBack();
        },

        /**
         * $el.paging() widget
         * @param  {Object} options See default options
         */
        init: function(options) {
            this.options = _.extend({}, this.options, options);

            this.options.elementSelector = options.elementSelector;
            this.$elements = this.$(this.options.elementSelector);
            this.$container = this.$(this.options.containerSelector);

            if (this.$elements.length) {
                this.render();
                this._initMouseScroll();

                this.$el.on('custompaging:endAnimation', this._updateArrows.bind(this));
            }
        },

        /**
         * Logic for scrolling via mouse, almost as drag&drop
         */
        _initMouseScroll: function() {
            var containerEl = this.$container[0];

            if (device.formFactor === 'desktop') {
                containerEl.onmousedown = function(e) {
                    var currentTarget = e.currentTarget;
                    var startingPosition = e.pageX;
                    var startingScroll = containerEl.scrollLeft;
                    var MOVE_OFFSET_TO_PREVENT_CLICK = 10;

                    document.onmousemove = function(event) {
                        containerEl.scrollLeft = startingScroll + Math.ceil(startingPosition - event.pageX);

                        if (Math.abs(startingPosition - e.pageX) > MOVE_OFFSET_TO_PREVENT_CLICK) {
                            currentTarget.onclick = function(eventClick) {
                                eventClick.stopPropagation();
                                currentTarget.onclick = null;
                            };
                        }

                        _.throttle(this._updateMouseMove(), this.options.throttleValue);
                    }.bind(this);

                    document.onmouseup = function() {
                        document.onmousemove = null;
                        document.onmouseup = null;

                        this._mouseScrollCallback();

                    }.bind(this);
                }.bind(this);

                containerEl.ondragstart = function() {
                    return false;
                };
            } else {
                containerEl.onscroll = _.debounce(function() {
                    this._updateMouseMove();
                    this._mouseScrollCallback();
                }.bind(this), this.options.throttleValue);
            }
        },

        /**
         * Update arrows visibility after scroll via mouse
         */
        _updateMouseMove: function() {
            this._updateArrows();
        },

        /**
         * Update activeItem index after scroll via mouse & fire callback if needed
         */
        _mouseScrollCallback: function() {
            var found = false;

            this.$elements.forEach(function(elementEl, index) {
                if (!found && $(elementEl).isInViewportByPercentage(0.1)) {
                    this.options.activeItem = index;
                    found = true;
                }
            }.bind(this));
        },

        /**
         * Base render method
         */
        render: function() {
            this.$el.addClass('custompaging');

            if (this.$elements && this.$elements.length > this.options.itemCountToShow) {
                this._renderControls();
            }

            this.triggerChangeCallback();
            return this;
        },

        /**
         * Render arrows if enabled + update arrows visibility
         */
        _renderControls: function() {
            if (_.contains(this.options.showArrowsOnDevices, device.formFactor)) {
                this.options.usingArrows = true;
                this.$('.fn-custom-paging').append(tmpl['custompaging.widget.arrowleft']({}));
                this.$('.fn-custom-paging').append(tmpl['custompaging.widget.arrowright']({}));

                this.on(this.$el, {
                    'tap .fn-goto-previous': this.gotoPrevious,
                    'tap .fn-goto-next': this.gotoNext
                }, this);

                _.delay(this._updateArrows.bind(this), 100);
            }
        },

        getFirstItemIndex: function() {
            var containerEl = this.$container[0];
            return _.findIndex(this.$elements, function(el) {
                return el.offsetLeft + el.offsetWidth - containerEl.scrollLeft > 0;
            });
        },

        getLastItemIndex: function() {
            var containerEl = this.$container[0];
            return _.findLastIndex(this.$elements, function(el) {
                return containerEl.scrollLeft + containerEl.offsetWidth - el.offsetLeft > 0;
            });
        },

        scrollToElementIndex: function(fromElementIndex, dir) {
            var toElementIndex = fromElementIndex + dir * this.options.itemCountToScroll;

            if (dir > 0) {
                toElementIndex = Math.min(toElementIndex, this.$elements.length - 1);
            } else {
                toElementIndex = Math.max(0, toElementIndex);
            }

            return toElementIndex;
        },

        getScrollOffsetToElementByIndex: function(toElementIndex, dir) {
            var scrollOffset;
            var el = this.$elements[toElementIndex];
            var containerEl = this.$container[0];

            if (dir > 0) {
                scrollOffset = el.offsetLeft - containerEl.scrollLeft;
            } else {
                scrollOffset = el.offsetLeft + el.offsetWidth - containerEl.scrollLeft - containerEl.offsetWidth;
            }

            return scrollOffset;
        },

        getIsStartScroll: function() {
            var containerEl = this.$container[0];

            return containerEl && Math.floor(containerEl.scrollLeft) === 0;
        },

        getIsEndScroll: function() {
            var containerEl = this.$container[0];

            return containerEl && containerEl.scrollWidth <= Math.ceil(containerEl.scrollLeft + containerEl.offsetWidth);
        },

        /**
         * Go to previous page
         */
        gotoPrevious: function(e) {
            if (!this.getIsStartScroll()) {
                var dir = -1;
                var lastItemIndex = this.getLastItemIndex();
                var scrollToElementIndex = this.scrollToElementIndex(lastItemIndex, dir);
                this.scrollTo(scrollToElementIndex, dir, null, e);
            }

            e && e.stopPropagation && e.stopPropagation();
        },

        /**
         * Go to next page
         */
        gotoNext: function(e) {
            if (!this.getIsEndScroll()) {
                var dir = 1;
                var firstItemIndex = this.getFirstItemIndex();
                var scrollToElementIndex = this.scrollToElementIndex(firstItemIndex, dir);
                this.scrollTo(scrollToElementIndex, dir, null, e);
            }

            e && e.stopPropagation && e.stopPropagation();
        },

        /**
         * Scroll to item by index and direction
         * @param  {Number}     index
         * @param  {Number}     direction
         * @param  {Function}   callback
         * @param  {Event}      event
         */
        scrollTo: function(index, dir, callback, event) {
            this._scroll(index, dir, callback);

            this.$el.trigger($.Event('custompaging:pageChanged', {
                originalTarget: event ? event.currentTarget : null
            }));
        },

        /**
         * Update arrow visibility after scroll
         */
        _updateArrows: function() {
            this.triggerChangeCallback();

            if (!this.options.usingArrows) {
                return;
            }

            var isStartScroll = this.getIsStartScroll();
            var isEndScroll = this.getIsEndScroll();

            this.$('.fn-goto-previous').toggleClass('hidden', isStartScroll);
            this.$('.fn-goto-next').toggleClass('hidden', isEndScroll);
        },

        /**
         * Animated scroll to index item
         * @param  {Number}     index
         * @param  {Number}     direction
         * @param  {Function}   callback
         */
        _scroll: function(index, dir, callback) {
            var scrollStartingValue = this.$container[0].scrollLeft;
            var scrollOffset = this.getScrollOffsetToElementByIndex(index, dir);
            var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame ||
                window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
            var startedTimestamp = (new Date()).getTime();

            this._scrollTick(requestAnimationFrame, startedTimestamp, scrollStartingValue, scrollOffset, callback);
        },

        /**
         * Scroll iterative method to change scroll value according to animation
         */
        _scrollTick: function(requestAnimationFrame, startedTimestamp, scrollStartingValue, scrollOffset, cb) {
            var nowTimestamp = new Date().getTime();
            var timeDelta = Math.min(1, (nowTimestamp - startedTimestamp) / this.options.animationTime);
            var timeFunction = Math.pow(timeDelta, 0.5);
            var containerEl = this.$container[0];

            containerEl.scrollLeft = Math.ceil(timeFunction * scrollOffset + scrollStartingValue);

            if (timeFunction < 1) {
                requestAnimationFrame(this._scrollTick.bind(this, requestAnimationFrame, startedTimestamp, scrollStartingValue, scrollOffset, cb));
            } else {
                this.$el.trigger('custompaging:endAnimation');
                cb && cb();
            }
        },

        /**
         * Widget destructor
         * @override
         */
        destroy: function() {
            this.$el.removeClass('custompaging');
            this.$container[0].onmousedown = null;

            return $.Widget.prototype.destroy.call(this);
        }
    });
});
